import { useMemo } from 'react';
import { getClassContentTree } from '../../utils/content-tags';
import { learningSubjectIsChinese } from '../../utils/learning-subject';
import { useContentTags } from './useContentTags';

export function useGlobalCurriculumTree(learningSubject) {
  const { globalCurriculumTree } = useContentTags();

  return useMemo(() => {
    const isChinese = learningSubjectIsChinese(learningSubject);
    return getClassContentTree(globalCurriculumTree).filter((tag) => {
      const isEnglishTag = tag.title.startsWith('English:');
      return isChinese ? !isEnglishTag : isEnglishTag;
    });
  }, [globalCurriculumTree, learningSubject]);
}
